"use strict";

import angular from "angular";

import "./themes/popup-feature.scss";
import "./themes/popup-feature-dark.scss";

export class PopupFeatureCtrl {
    currentTab = 0;
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
        this.title = angular.copy(this.locals.title);
    }

    $onInit() {
        this.setSteps();
    }

    setSteps() {
        if (this.locals.features?.length) {
            this.locals.title = `${this.title} ${this.currentTab + 1}/${
                this.locals?.features?.length || 1
            }`;
        }
    }

    nextStep() {
        if (this.currentTab >= this.locals.features?.length - 1) {
            this.$mdDialog.hide(true);
        }
        this.currentTab =
            this.currentTab >= this.locals.features?.length - 1
                ? this.currentTab
                : this.currentTab + 1;
        this.setSteps();
    }

    backStep() {
        if (this.currentTab <= 0) {
            this.$mdDialog.hide(true);
        }
        this.currentTab = this.currentTab <= 0 ? 0 : this.currentTab - 1;
        this.setSteps();
    }

    action(type) {
        this.$mdDialog.hide(type);
    }
}

angular.module("nucont.shared").controller("PopupFeatureCtrl", ["$mdDialog", "locals", PopupFeatureCtrl]);
